<template>
	<select class="form-control" @change="itemSelected">
		<option v-for="solution in solutions" :value="solution.id">
			{{ solution.name }}
		</option>
		<option v-if="isLoaded==false">
			Cargando opciones...
		</option>
	</select>
</template>

<script>
	export default {
		data() {
			return {
				solutions: [],
				isLoaded: false
			}
		},

		mounted() {
			this.getSolutions();
		},

		methods: {
			async getSolutions() {
				const url = `${process.env.VUE_APP_ROOT_API}/solution`;
				const response = await fetch(url);
				this.solutions = await response.json();
				this.isLoaded = true;
			},

			itemSelected(e) {
				this.$emit('item-selected', e.target.value);
			}
		}
	}
</script>